// 盘古项目新增引导页，放在Main下面，做全路由拦截

import React, { Component } from 'react'
import { Button } from 'hljd'
import styles from './style.module.less'
import { observer } from 'mobx-react'
import Store from './store'
import { withRouter } from 'react-router'
@observer
class Shangshangqian extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }
  componentDidMount() {
    const { isShowPangu, isActiveStore } = this.props
    // 非灰度商家，无论激活非激活，都不显示弹窗
    // 灰度商家且激活商家，直接重定向至盘古
    if (isShowPangu && !isActiveStore) {
      this.setAsyncRouteLeaveHook()
    }
  }
  setAsyncRouteLeaveHook = () => {
    const { router } = this.props
    router.setRouteLeaveHook(this.props.routes[2], nextLocation => {
      // 判断数据进行了修改，路由离开提示
      this.routerWillLeave(nextLocation)

      return false
    })
  }

  // 路由离开前做提示
  routerWillLeave = nextLocation => {
    const { setVisible } = this.store
    setVisible(true)
  }
  render() {
    const { visible, onCancle, recordStoreJumpMode } = this.store
    const { isShowPangu, isActiveStore, isClose } = this.props
    // 非灰度商家，无论激活非激活，都不显示弹窗
    // 灰度商家且激活商家，直接重定向至盘古
    // 灰度商家且非激活商家，显示弹窗
    return isShowPangu && !isActiveStore && visible ? (
      <div className={styles.mask}>
        <div className={styles.content}>
          <div className={styles.top} />
          {isClose && (
            <div className={styles.close} onClick={() => onCancle()} />
          )}
          <div className={styles.bottom}>
            <div className={styles.text}>
              婚礼纪商家后台已正式升级 请进入新系统使用相关功能
            </div>
            <Button
              type="primary"
              size="large"
              onClick={() => recordStoreJumpMode()}
            >
              进入新系统
            </Button>
          </div>
        </div>
      </div>
    ) : null
  }
}

export default withRouter(Shangshangqian)
